<template lang="pug">
.pm-af-team(:class="this.$props.club1 ? '' : 'pm-af-team--visitor'")
    .pm-af-team__shield: img(:src="this.$props.teamImage")
    .pm-af-team-match-list
        .pm-af-team-match(
            v-for="match in this.$props.lastMatches" 
            :class = "match.is_local ? '' : 'pm-af-team-match--visitor'"
            @click="selectMatch(match)"
            )
            .pm-match_info.pm-af-team-match-info
                span.pm-match_info__comp {{ match.competition.official_name }}
                span.pm-match_info__time {{ match.matchweek_descriptor }} - {{parsedDate(match.date,match.time)}}

            span.ge__streak.ge__streak--big.pm-af-team-match__result(
                v-text="(match.result === 'V') ?  $t('W') : $t('L')"
                :class="(match.result === 'V') ? 'ge__streak--win' : 'ge__streak--lose'"
            )
            img.pm-af-team-match__rival(:src="match.opponent_image")
            .pm-af-team-match-score-wrap.nav-day-match-wrap
                .pm-af-team-match-score.pm-af-team-match-score--l {{ match.score_local }}
                .pm-af-team-match-score.pm-af-team-match-score--v {{ match.score_visitor }}

            img.pm-af-team-match__rival(:src="match.opponent_image")

            i.pm-af-team-match__arrow(v-if="match.id_edition >= $store.state.general.oldestACBLeagueEdition")
                font-awesome-icon(icon="arrow-right")


</template>
<script>

export default {
    props: {
        lastMatches: Array,
        teamImage: String,
        club1: Boolean,
    },
    methods: {
        selectMatch(match) {
            this.$parent.selectMatch(match);
        },
        parsedDate(date, time) {
            let match_date = new Date((date + time) * 1000)
            function pad(s) { return (s < 10) ? '0' + s : s; }
            return [pad(match_date.getDate()), pad(match_date.getMonth() + 1), match_date.getFullYear()].join('/')
        },
    }

};
</script>